<template>
  <div class="container mb-5">
    <div class="row mb-5 my-md-5">
      <div class="col-sm-6 offset-sm-3">
        <h1 class="text-center">
          {{ $t("cliente", 2) }}
        </h1>
      </div>
    </div>
    <ClientesTable />
    {{ $t("clientesLGPD") }}
  </div>
</template>

<script>
import ClientesTable from './components/ClientesTable.vue';

export default {
  components: { ClientesTable },
};
</script>
